import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { IconButton, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";

interface Props {
  readonly value: string;
  readonly fullWidth?: boolean;
  readonly onChange: (query: string) => void;
}

const TextSearch: FC<Props> = ({ value, fullWidth, onChange }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (value: string) => {
    setLocalValue(value);
    debouncedOnChange(value);
  };

  const debouncedOnChange = useCallback(
    debounce(
      (newValue: string) => {
        onChange(newValue);
      },
      500,
      {},
    ),
    [onChange],
  );

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
        flexGrow: fullWidth ? 1 : undefined,
      }}
    >
      <SearchIcon />
      <TextField fullWidth value={localValue} label="Szukaj" onChange={(e) => handleChange(e.target.value)} />
      <IconButton color="inherit" onClick={() => handleChange("")}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default TextSearch;
